const state = {
	// 扫码的值
	scanString: ''
}

// 以计算属性形式返回
const getters = {
	scanString: state => state.scanString
}

// 异步获取值后commit mutations更改值
const actions = {
	
}

// 更改值
const mutations = {
	SET_SCANSTRING: (state, scanString) => {
		console.log(scanString);
	  state.scanString = scanString
		console.log(state.scanString);
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/scanCode.js